import React from "react";
import ExerciseService from '../../services/exercise';
import {toast} from "react-toastify";
import AtomToast from "@atoms/toastify/AtomToast";
import {AlertTriangle, CheckCircle, XCircle} from "react-feather";
import {EXERCISE_REDIRECT_SUCCESSFULL, EXERCISE_RESULTS_URL} from "@src/utility/Constant";
import ReferralService from "@src/services/referral";


export const changeReloadStatus = (type, status) => {
	return async (dispatch) => {
		try {
			dispatch({
				type: type,
				payload: status,
			});
		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const createReferralCode = () => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			await referralService.createReferralCode();
			toast.success(
				<AtomToast
					title={"Sukses"}
					content={`Kode Referral Berhasil Dibuat`}
					color={"success"}
					icon={<CheckCircle size={12}/>}
				/>
			);
			dispatch({
				type: 'RELOAD_REFERRAL_INFO_SECTION',
				payload: true,
			});
		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const saveMyCardInfo = (cardInfo) => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			await referralService.saveMyCardInfo(cardInfo);
			toast.success(
				<AtomToast
					title={"Sukses"}
					content={`Informasi Kartu Berhasil Diupdate`}
					color={"success"}
					icon={<CheckCircle size={12}/>}
				/>
			);
			dispatch({
				type: 'RELOAD_REFERRAL_CARD_SECTION',
				payload: true,
			});
		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const requestWithdraws = (cardInfo) => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			await referralService.requestWithdraws(cardInfo);
			toast.success(
				<AtomToast
					title={"Sukses"}
					content={`Request Withdrawal Berhasil`}
					color={"success"}
					icon={<CheckCircle size={12}/>}
				/>
			);
		} catch (error) {
			console.error(error);
			toast.error(
				<AtomToast
					title={"Gagal"}
					content={`Request Withdrawal Gagal`}
					color={"danger"}
					icon={<CheckCircle size={12}/>}
				/>
			);
			// throw new Error(error?.message);
		}
	};
};

export const getMyBalance = () => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			const data = await referralService.getMyBalance();

			if(data !== null) {
				dispatch({
					type: 'SET_REFERRAL_BALANCE',
					payload: data.balance,
				});
			}

		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const getListBank = () => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			const bankList = await referralService.getListBank();

			dispatch({
				type: 'SET_REFERRAL_BANK_LIST',
				payload: bankList,
			});

		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const getMyCard = () => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			const bankList = await referralService.getMyCard();

			dispatch({
				type: 'SET_REFERRAL_MY_CARD',
				payload: bankList,
			});

		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const getInfoReferral = () => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			const referral = await referralService.getInfoReferral();

			dispatch({
				type: 'SET_REFERRAL_INFO',
				payload: referral,
			});

		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const detailWithdrawal = (withdrawId) => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			const withdrawal = await referralService.detailWithdrawal({withdraw_id:withdrawId});

			dispatch({
				type: 'SET_REFERRAL_WITHDRAWAL_DETAIL',
				payload: withdrawal,
			});

		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const getWithdrawalHistory = () => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			const withdrawals = await referralService.getWithdrawalHistory();

			dispatch({
				type: 'SET_REFERRAL_WITHDRAWAL_HISTORY',
				payload: withdrawals,
			});

		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

export const getListReferralTransaction = () => {
	return async (dispatch) => {
		try {
			const referralService = new ReferralService();
			const referralTx = await referralService.getListReferralTransaction();

			dispatch({
				type: 'SET_REFERRAL_TRANSACTION',
				payload: referralTx,
			});

		} catch (error) {
			console.error(error);
			throw new Error(error?.message);
		}
	};
};

